import * as r from '@recoiljs/refine';
import { atom } from 'recoil';
import { urlSyncEffect } from 'recoil-sync';

export interface EmployeeByActivityPoleFilterAtom {
	jobTitle: string[];
	coordination: string[];
	management: string[];
	workstation: string[];
	board: string[];
	pole: string[];
	activity: string[];

	conditionTraining: string[];
	conditionStatus: string[];
	showAllEmployees: boolean;
}

const stringArrayChecker = r.array(r.string()) as r.Checker<string[]>;

export const employeeByActivityPoleFilterAtom =
	atom<EmployeeByActivityPoleFilterAtom>({
		key: 'employeeByActivityPoleFilterAtom',
		default: {
			jobTitle: [],
			coordination: [],
			management: [],
			workstation: [],
			pole: [],
			activity: [],
			board: [],
			conditionTraining: [],
			conditionStatus: [],
			showAllEmployees: false,
		},
		effects: [
			urlSyncEffect<EmployeeByActivityPoleFilterAtom>({
				refine: r.object({
					jobTitle: stringArrayChecker,
					coordination: stringArrayChecker,
					management: stringArrayChecker,
					workstation: stringArrayChecker,
					board: stringArrayChecker,
					pole: stringArrayChecker,
					activity: stringArrayChecker,
					conditionTraining: stringArrayChecker,
					conditionStatus: stringArrayChecker,
					showAllEmployees: r.custom((value) => {
						if (typeof value === 'boolean') {
							return value;
						}
						if (typeof value === 'string') {
							return value === 'true';
						}
						return true;
					}),
				}),
				history: 'push',
			}),
		],
	});
